import React, { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import './Performers.css';
import '../styles/neon.css';

import djViolaImg from '../assets/performers/DJ2.png';
import shashwatImg from '../assets/performers/sing2.png';
import bandImg from '../assets/performers/band2.png';

// Using placeholders for the performers. 
// The user will replace these with actual cutout images later.
const performersData = [
    {
        id: 1,
        name: "Dj viola",
        date: "27th Feb 2026",
        position: 'left',
        image: djViolaImg,
        instagram: 'https://www.instagram.com/dj_viola_?igsh=NzV1bDJ0d2Q2b3p6'
    },
    {
        id: 3,
        name: "Shashwat Singh",
        date: "27th Feb 2026",
        position: 'right',
        image: shashwatImg,
        instagram: 'https://www.instagram.com/shashwatsinghofficial?igsh=MTJxcjV0MW4wMGhreA%3D%3D'
    },
    {
        id: 2,
        name: "Underground Authority ",
        date: "28th Feb 2026",
        position: 'center',
        image: bandImg,
        instagram: 'https://www.instagram.com/ua_official_insta?igsh=MTdxZ2Uybmt2YjBiYw%3D%3D'
    }
];

const Performers = () => {
    const [, setLocation] = useLocation();
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        // Trigger entrance animations shortly after mounting
        const timer = setTimeout(() => setAnimate(true), 100);
        return () => clearTimeout(timer);
    }, []);

    const handleBack = () => {
        setLocation('/');
    };

    return (
        <div className="performers-container">
            <div className="stage-wrapper">
                <h1 className="performers-title neon-text-pink flicker-fast">
                    THE STAGE IS SET
                </h1>
                <p className="performers-subtitle neon-text-cyan">
                    Three epic events. One massive stage.
                </p>

                <div className="stage-3d-scene">
                    {performersData.map((performer) => (
                        <div
                            key={performer.id}
                            className={`performer-card pos-${performer.position} ${animate ? 'animate-in' : ''}`}
                        >
                            <div className="performer-image-wrapper">
                                <img src={performer.image} alt={performer.name} className="performer-image" loading="lazy" decoding="async" />
                                <div className="performer-spotlight"></div>
                            </div>

                            <div className="performer-details">
                                <h3 className="performer-name">
                                    {performer.name}
                                </h3>
                                <div className="performer-datetime">
                                    <span className="date">{performer.date}</span>
                                </div>
                                {performer.instagram && (
                                    <a href={performer.instagram} target="_blank" rel="noopener noreferrer" className="performer-instagram">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm3.98-10.169a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                                        </svg>
                                    </a>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="stage-lasers">
                {/* Broad Spotlights (Background sweeps) */}
                <div className="laser broad blue"></div>
                <div className="laser broad pink"></div>
                <div className="laser broad blue"></div>
                <div className="laser broad pink"></div>
                <div className="laser broad blue"></div>
                <div className="laser broad pink"></div>

                {/* Sharp Lasers */}
                <div className="laser blue"></div>
                <div className="laser pink"></div>
                <div className="laser blue center-pulse"></div>
                <div className="laser pink offset"></div>
            </div>
            <div className="ground-fog"></div>
        </div>
    );
};

export default Performers;
